module.exports = __webpack_public_path__ + "static/media/sortable-arrow-down_16.47279965.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/icons/lib/sortable-arrow-down_16.svg
// module id = 909
// module chunks = 0